import React, { CSSProperties, useEffect, useState } from "react";
import VoucherDetailTable from "../../components/tables/VoucherDetailTable";
import { useGetMyVouchers } from "../../api/agro_dealer";
import { useLocation, useParams } from "react-router-dom";
import { useGetVoucherById } from "../../api/voucher";
import { Checkbox, Collapse, Table, Tabs } from "antd";
import { title } from "process";

const getStatusColor = (status: string) => {
  let color = "#FFC107";
  switch (status) {
    case "REDEEMED":
      color = "#32a852";
      break;
    case "PARTIALLY REDEEMED":
      color = "#FFA500";
      break;
    case "ISSUED":
      color = "#cc5866";
      break;
    case "VOID":
      color = "#555555";
      break;
    case "PAID":
      color = "#32a852";
      break;
    case "PENDING":
      color = "#32a852";
      break;
    default:
      color = "#FFC107";
      break;
  }

  return color;
};

const wrapper: CSSProperties = {
  display: "flex",
  width: "100%",
  // gap: 10,
  fontSize: 16,
  // marginBottom: 20,
  flexDirection: "column",
};
const label: CSSProperties = {
  color: "#128807",
  fontWeight: 500,
  fontSize: 20,
};
const value: CSSProperties = {
  color: "#8590A3",
  fontWeight: 500,
  fontSize: 16,
};

const voucherColumns = [
  {
    dataIndex: "orgName",
    title: "Agro Dealer",
    render: (orgName: string, record: any) => (
      <div className="flex flex-col items-start">
        <div>{orgName}</div>
        <div className="text-gray-400">{record.orgPhoneNumber}</div>
      </div>
    ),
  },
  {
    dataIndex: "fullName",
    title: "Redeemed By",
    render: (fullName: string, record: any) => (
      <div className="flex flex-col items-start">
        <div>{fullName}</div>
        <div className="text-gray-400">{record.phoneNumber}</div>
      </div>
    ),
  },

  {
    dataIndex: "redemptionDate",
    title: "Redemption Date",
  },
  {
    dataIndex: "status",
    title: "Payment Status",
    render: (status: number) => {
      const _status = status === 1 ? "PENDING" : "PAID";
      return (
        <div
          className={`flex justify-center items-center w-4/5 py-[6px] rounded-xl`}
          style={{
            color: getStatusColor(_status),
            backgroundColor: `${getStatusColor(_status)}44`,
          }}
        >
          {status === 1 ? "Pending" : "Paid"}
        </div>
      );
    },
  },
];

const VoucherDetailPage = () => {
  const { id } = useParams();
  const { data: voucher, isLoading, refetch } = useGetVoucherById(id);
  const [viewAll, setViewAll] = useState(false);
  const [viewAllVoucherDetails, setViewAllVoucherDetails] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [voucherTableData, setVoucherTableData] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    if (id) {
      refetch();
    }
  }, [id]);

  useEffect(() => {
    if (
      voucher &&
      voucher.data &&
      voucher.data.data &&
      voucher.data.data.entitlementDetail
    ) {
      const _data = voucher.data.data.entitlementDetail.map((item: any) => {
        return {
          id: item.id,
          inputName: item.input.inputName,
          quantity: `${item.quantity} ${item.input.unitOfMeasurementName}`,
          unitPrice: item.unitPrice,
          totalPrice: item.totalPrice,
          landSize: item.landSize,
          status: item.voucherStatus,
        };
      });

      setTableData(_data);
    }

    if (
      voucher &&
      voucher.data &&
      voucher.data.data &&
      voucher.data.data.redemptions
    ) {
      const _redemptionsData = voucher.data.data.redemptions.map(
        (item: any, index: number) => {
          return {
            id: index,
            fullName: item.redeemedBy.fullName,
            phoneNumber: item.redeemedBy.phoneNo,
            orgName: item.agroDealer.orgName,
            orgPhoneNumber: item.agroDealer.phoneNo,
            redemptionDate: item.redemptionDate,
            status: item.txnStatus,
          };
        },
      );

      setVoucherTableData(_redemptionsData);
    }
  }, [voucher]);

  const getStatusText = (_status: number) => {
    let status = "ISSUED";
    switch (_status) {
      case 1:
        status = "VOID";
        break;
      case 2:
        status = "ISSUED";
        break;
      case 3:
        status = "REDEEMED";
        break;
      case 4:
        status = "PARTIALLY REDEEMED";
        break;
    }
    return status;
  };

  const columns = [
    {
      dataIndex: "inputName",
      title: "Input name",
    },
    {
      dataIndex: "quantity",
      title: "Quantity",
    },
    {
      dataIndex: "unitPrice",
      title: "Unit Price",
    },
    {
      dataIndex: "totalPrice",
      title: "Total Price",
    },
    {
      dataIndex: "landSize",
      title: "Land Size (Hac)",
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (status: number) => {
        let _status = getStatusText(status);

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "80%",
              paddingTop: 6,
              paddingBottom: 6,
              borderRadius: 8.5,
              color: getStatusColor(_status),
              backgroundColor: `${getStatusColor(_status)}44`,
            }}
          >
            {_status}
          </div>
        );
      },
    },
  ];

  const tabitems = [
    {
      key: "1",
      label: "VOUCHER DETAIL",
      children: (
        <div className="w-full">
          <div
            className="px-4 py-2 md:px-[50px] md:pt-[33px] md:pb[33px] bg-white rounded-xl"
            style={{
              fontFamily: "Poppins",
              fontWeight: 700,
            }}
          >
            <div
              style={{
                backgroundColor: "#E9EDF4",
                padding: "15px",
                borderRadius: "8.5px",
                fontWeight: 500,
                fontSize: "24px",
                marginBottom: "30px",
              }}
            >
              Voucher detail
            </div>
            <div className="grid grid-cols-2">
              <div style={wrapper}>
                <div style={label}>Voucher code</div>
                <div style={value}>
                  {voucher?.data.data.voucher.voucherCode || "N/A"}
                </div>
              </div>

              <div style={wrapper}>
                <div style={label}>Voucher price</div>
                <div style={value}>
                  {voucher?.data.data.voucher.inputPayed || "N/A"}
                </div>
              </div>

              <div style={wrapper}>
                <div style={label}>Issued date</div>
                <div style={value}>
                  {voucher?.data.data.voucher.issuanceDate || "N/A"}
                </div>
              </div>

              <div style={wrapper}>
                <div style={label}>Expiry date</div>
                <div style={value}>
                  {voucher?.data.data.voucher.expiryDate || "N/A"}
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <div style={wrapper}>
                <div style={label}>Product</div>
                <div style={value}>
                  {voucher?.data.data.contract.productItemDto.name || "N/A"}
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <div style={wrapper}>
                <div style={{ ...label, borderBottom: "1px solid #8590A3" }}>
                  Issued by
                </div>
              </div>
              <div className="w-full grid grid-cols-2 md:grid-cols-4 mt-5">
                <div style={wrapper}>
                  <div style={label}>Full name</div>
                  <div style={value}>
                    {voucher?.data.data.voucher.issuedBy.fullName || "N/A"}
                  </div>
                </div>

                <div style={wrapper}>
                  <div style={label}>Phone No.</div>
                  <div style={value}>
                    {voucher?.data.data.voucher.issuedBy.phoneNo || "N/A"}
                  </div>
                </div>

                <div style={wrapper}>
                  <div style={label}>Email</div>
                  <div style={value}>
                    {voucher?.data.data.voucher.issuedBy.email || "N/A"}
                  </div>
                </div>

                <div style={wrapper}>
                  <div style={label}>Status</div>
                  <div
                    style={{
                      ...value,
                      width: 150,
                      borderRadius: 8,
                      color: getStatusColor(
                        getStatusText(voucher?.data.data.voucher.voucherStatus),
                      ),
                      backgroundColor: `${getStatusColor(
                        getStatusText(voucher?.data.data.voucher.voucherStatus),
                      )}44`,
                    }}
                    className="flex py-2 px-4 justify-center items-center"
                  >
                    {getStatusText(voucher?.data.data.voucher.voucherStatus) ||
                      "N/A"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: "CUSTOMER INFORMATION",
      children: (
        <div style={{ width: "100%" }}>
          <div
            className="px-4 py-2 md:px-[50px] md:pt-[33px] md:pb[33px] bg-white rounded-xl"
            style={{
              fontFamily: "Poppins",
              fontWeight: 700,
            }}
          >
            <div
              style={{
                backgroundColor: "#E9EDF4",
                padding: "15px",
                borderRadius: "8.5px",
                fontWeight: 500,
                fontSize: "24px",
                marginBottom: "30px",
              }}
            >
              Customer information
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <div style={wrapper}>
                <div style={label}>Full name</div>
                <div style={value}>
                  {voucher?.data.data.customer.bankAccountName || "N/A"}
                </div>
              </div>

              <div style={wrapper}>
                <div style={label}>Customer ID.</div>
                <div style={value}>
                  {voucher?.data.data.customer.customerId || "N/A"}
                </div>
              </div>

              <div style={wrapper}>
                <div style={label}>Gender</div>
                <div style={value}>
                  {voucher?.data.data.customer.gender || "N/A"}
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <div style={wrapper}>
                <div style={label}>Phone No.</div>
                <div style={value}>
                  {voucher?.data.data.customer.phoneNumber || "N/A"}
                </div>
              </div>

              <div style={wrapper}>
                <div style={label}>Account No.</div>
                <div style={value}>
                  {voucher?.data.data.customer.bankAccount || "N/A"}
                </div>
              </div>

              <div style={wrapper}>
                <div style={label}>TIN</div>
                <div style={value}>
                  {voucher?.data.data.customer.tinNumber || "N/A"}
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: "ENTITLEMENT",
      children: (
        <div className="hidden md:block" style={{ width: "100%" }}>
          <div
            style={{
              fontFamily: "Poppins",
              fontWeight: 700,
              borderRadius: "8.5px",
              backgroundColor: "white",
              paddingTop: "33px",
              paddingBottom: "33px",
              paddingRight: 50,
              paddingLeft: 50,
            }}
          >
            <div
              style={{
                backgroundColor: "#E9EDF4",
                padding: "15px",
                borderRadius: "8.5px",
                fontWeight: 500,
                fontSize: "24px",
                marginBottom: "30px",
              }}
            >
              Entitlement
            </div>
            <Table columns={columns} dataSource={tableData} />
          </div>
        </div>
      ),
    },
    {
      key: "4",
      label: "REDEMPTION",
      children: (
        <div className="hidden md:block" style={{ width: "100%" }}>
          <div
            className="rounded-xl bg-white py-[33px] px-[50px]"
            style={{
              fontFamily: "Poppins",
              fontWeight: 700,
            }}
          >
            <div
              className="bg-[#E9EDF4] p-[15px] rounded-xl mb-[30px]"
              style={{
                fontWeight: 500,
                fontSize: "24px",
              }}
            >
              Redemption
            </div>
            <Table columns={voucherColumns} dataSource={voucherTableData} />
          </div>
        </div>
      ),
    },
  ];
  return (
    <Tabs
      style={{
        background: "white",
        fontWeight: 700,
        paddingLeft: 20,
      }}
      className="text-black"
      defaultActiveKey="1"
      items={tabitems}
      onChange={(key) => setActiveTab(key)}
    />
  );
};

export default VoucherDetailPage;
